<template>
  <div class="flex space-x-3">
    <div
      data-cy="activity-card"
      class="flex h-10 w-10 flex-none items-center justify-center rounded-full"
      :class="backgroundClass"
    >
      <slot name="icon" />
    </div>
    <div class="flex min-w-0 grow flex-col rounded-md bg-white shadow-main">
      <div v-if="title" class="bg-grey-hover px-5 py-3">
        <p class="text-xs font-semibold text-headline">
          {{ title }}
        </p>
      </div>
      <slot name="content" />
      <div
        class="log-footer flex items-center justify-between space-x-4 p-4 shadow-sm"
      >
        <slot name="footer" />
        <log-comments-toggle
          v-model="showComments"
          :count="comments?.length ?? 0"
        />
      </div>
      <log-comments-section v-if="showComments" :comments="comments" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import LogCommentsToggle from "@/components/communicationLogs/comments/LogCommentsToggle.vue";
import LogCommentsSection from "@/components/communicationLogs/comments/LogCommentsSection.vue";

import type { CommunicationLogComment } from "@/models/communicationLogs";

defineProps<{
  title?: string;
  backgroundClass?: string;
  comments?: CommunicationLogComment[];
}>();

const showComments = ref(false);
</script>

<style scoped>
.log-footer {
  container-type: inline-size;
  container-name: log-footer;
}

@container log-footer (min-width: 750px) {
  :deep() {
    .wrapper {
      @apply space-x-2;
    }
  }
}

@container log-footer (max-width: 750px) {
  :deep() {
    .wrapper,
    .wrap-children {
      @apply -ml-1 -mr-1 flex-wrap;
      > div {
        @apply p-1;
      }
    }
  }
}
</style>
